<h2 class="text-xl font-bold mb-4">Inhalt angemessen</h2>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-green-600 flex items-center mb-2">
    <span class="mr-2">✅</span> Akzeptieren, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>
      Der Inhalt den Richtlinien der Plattform entspricht (keine beleidigenden,
      diskriminierenden, illegalen oder unangemessenen Inhalte).
    </li>
    <li>Der Inhalt sachlich, seriös und thematisch relevant ist.</li>
  </ul>
</div>

<div class="mb-6">
  <h3 class="text-lg font-semibold text-red-600 flex items-center mb-2">
    <span class="mr-2">❌</span> Ablehnen, wenn:
  </h3>
  <ul class="list-disc ml-6 space-y-2">
    <li>Der Inhalt gegen rechtliche oder ethische Standards verstößt.</li>
    <li>
      Beleidigende, diskriminierende oder anstößige Sprache verwendet wird.
    </li>
    <li>Irreführende oder falsche Informationen enthalten sind.</li>
    <li>Werbung oder Spam vorliegt.</li>
  </ul>
</div>

<div class="mt-4 p-4 bg-blue-50 rounded-lg">
  <p class="flex items-center text-blue-800">
    <span class="mr-2">➡</span>
    <span class="font-semibold">Best Practice:</span>
    Falls abgelehnt, muss der Antragsteller mit einer nachvollziehbaren
    Begründung benachrichtigt werden. Der Prozess wird hier abgebrochen.
  </p>
</div>
